import { useEffect } from 'react';

function useDisableBodyScroll(mindContainerRef: React.RefObject<HTMLDivElement>): void {
  // input 不改变网页大小
  useEffect(() => {
    const chatAppMetaId = '_CHAT_APP_META_ID_';
    const metaEle = document.getElementById(chatAppMetaId);

    if (metaEle) {
      return;
    }

    const meta = document.createElement('meta');

    meta.id = chatAppMetaId;
    meta.name = 'viewport';
    meta.content =
      'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no';
    document.head.appendChild(meta);
  }, []);

  useEffect(() => {
    const fixedContainer = mindContainerRef.current;

    if (!fixedContainer) {
      return;
    }

    const eventAreaStart = (e: TouchEvent | MouseEvent) => {
      e.stopPropagation();
      document.body.style.overflow = 'hidden';
    };
    const eventAreaFinish = (e: TouchEvent | MouseEvent) => {
      e.stopPropagation();
      document.body.style.overflow = '';
    };

    // pc
    fixedContainer.addEventListener('mouseenter', eventAreaStart, false);
    fixedContainer.addEventListener('mouseleave', eventAreaFinish, false);
    // mobile
    fixedContainer.addEventListener('touchstart', eventAreaStart, false);
    fixedContainer.addEventListener('touchend', eventAreaFinish, false);
    fixedContainer.addEventListener('touchcancel', eventAreaFinish, false);

    return () => {
      // pc
      fixedContainer.removeEventListener('mouseenter', eventAreaStart);
      fixedContainer.removeEventListener('mouseleave', eventAreaFinish);
      // mobile
      fixedContainer.removeEventListener('touchstart', eventAreaStart);
      fixedContainer.removeEventListener('touchend', eventAreaFinish);
      fixedContainer.removeEventListener('touchcancel', eventAreaFinish);
    };
  }, [mindContainerRef]);
}

export default useDisableBodyScroll;
